import { render, staticRenderFns } from "./StudentReports.vue?vue&type=template&id=34fa49bf"
import script from "./StudentReports.vue?vue&type=script&lang=js"
export * from "./StudentReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports